var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-width btn-margin"},[_c('button',{attrs:{"id":"form_submit","name":"submit","type":"submit","disabled":_vm.disabled}},[_vm._v("\n    この内容でお見積り書を作成する\n    "),_c('br'),_vm._v("\n    (お客さま情報入力へ)\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }